<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <Card :bordered="false" dis-hover class="ivu-bg">
          <Row type="flex" justify="center" align="middle" class="ivu-text-center">
            <!-- <Col :xl="6" :lg="6" :md="6" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>待发货</p>
            <p style="font-size: 24px">{{ statistics.not_deliver }} 个订单</p>
            </Col> -->
            <Col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>今日全部订单</p>
            <p style="font-size: 24px">{{ statistics.today_order }} 个订单</p>
            </Col>
            <Col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>今日已完成订单</p>
            <p style="font-size: 24px">
              {{ statistics.success_order }} 个订单
            </p>
            </Col>
            <Col :xl="8" :lg="8" :md="8" :sm="24" :xs="24" class="ivu-mt ivu-mb">
            <p>今日订单收益</p>
            <p style="font-size: 24px">
              {{ statistics.today_money }} 元
            </p>
            </Col>
          </Row>
        </Card>
        <div class="card">
          <div class="card-head">订单管理</div>
          <div class="card-body padding-top0">
            <div class="card-menu">
              <Row>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <RadioGroup v-model="orderType" type="button" button-style="solid">
                  <Radio :label="-1">全部订单</Radio>
                  <Radio :label="0">未支付</Radio>
                  <!-- <Radio :label="1">待发货</Radio> -->
                  <Radio :label="2">已完成</Radio>
                </RadioGroup>
                </Col>
                <Col :xs="{ span: 24 }" :lg="{ span: 12 }" style="margin: 5px 0">
                <Input v-model="searchValue" placeholder="搜索">
                <Select v-model="searchType" slot="prepend" style="width: 120px">
                  <Option :value="1">手机号</Option>
                  <Option :value="2">商户订单号</Option>
                </Select>
                <Button slot="append" icon="ios-search" @click="searchClick"></Button>
                </Input>
                </Col>
              </Row>
              <Button type="error" icon="md-trash" @click="allDelNot" :loading="loading1">清理无效订单</Button>
              <Button type="error" icon="md-trash" style="margin-left:10px" @click="allDel" :loading="loading2"
                :disabled="Selection.length==0?true:false">删除所选</Button>
            </div>
            <div v-if="data.length == 0 && !load">
              <Empty :text="'暂无数据'"></Empty>
            </div>
            <div v-else>
              <Alert show-icon v-if="$store.state.isMobile">移动设备请左右滑动翻阅</Alert>
              <Table ref="selection" border :loading="load" :columns="columns" :data="data" @on-selection-change="handleSelectChange">
                <template slot-scope="{ row }" slot="trade_no">
                  <span> {{ row.trade_no }}</span>
                </template>
                <template slot-scope="{ row }" slot="type">
                  <Tag color="cyan" v-if="row.type == 1">自动发货</Tag>
                  <Tag color="blue" v-if="row.type == 2">手动发货</Tag>
                </template>
                <template slot-scope="{ row }" slot="payment">
                  <Tag color="primary" v-if="row.payment == 'alipay'">支付宝</Tag>
                  <Tag color="success" v-else>微信</Tag>
                </template>

                <template slot-scope="{ row }" slot="status">
                  <Badge v-if="row.status === 0" status="default" text="待支付" />
                  <Badge v-if="row.status === 1" status="warning" text="待发货" />
                  <Badge v-if="row.status === 2" status="success" text="已完成" />
                </template>
                <template slot-scope="{ row }" slot="action">
                  <Button type="primary" size="small" style="margin-right: 5px" @click="readOrder(row)">查看订单</Button>
                  <Button type="error" size="small" @click="del(row.out_trade_no)">删除</Button>
                </template>
              </Table>
              <div class="paging">
                <Page :total="Number(total)" :current="pageIndex" :page-size="pageSize" :simple="$store.state.isMobile"
                  @on-change="pageChange" @on-page-size-change="pageSizeChange" show-total show-sizer show-elevator />
              </div>
            </div>
          </div>
        </div>
        <Modal v-model="Modal" :title="rows.out_trade_no" :styles="{ top: '20px' }" width="750" footer-hide>
          <Form>
            <Row>
              <Col :xs="{ span: 12 }" :lg="{ span: 12 }">
              <FormItem label="订单ID："> {{ rows.id }} </FormItem>
              </Col>
              <Col :xs="{ span: 12 }" :lg="{ span: 12 }">
              <FormItem label="订单状态：">
                <Tag color="default" v-if="rows.status == 0">待支付</Tag>
                <Tag color="primary" v-if="rows.status == 1">待发货</Tag>
                <Tag color="success" v-if="rows.status == 2">已完成</Tag>
              </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="商户订单号：">
                {{ rows.out_trade_no }}
              </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="订单流水号："> {{ rows.trade_no }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="商品ID/名称：">
                {{ rows.goods_id }} / {{ rows.goods_name }}
              </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="规格名称："> {{ rows.norms_name }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="购买数量："> {{ rows.count }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="单价："> {{ rows.unit_price }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="订单总价："> {{ rows.price }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="付款金额："> {{ rows.money }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="订单类型：">
                <Tag color="cyan" v-if="rows.type == 1">自动发货</Tag>
                <Tag color="blue" v-if="rows.type == 2">手动发货</Tag>
              </FormItem>
              </Col>

              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="支付方式：">
                <Tag color="primary" v-if="rows.payment == 'alipay'">支付宝支付</Tag>
                <Tag color="success" v-else>微信支付</Tag>
              </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="创建时间："> {{ rows.addTime }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="支付时间："> {{ rows.endTime }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="发货时间："> {{ rows.deliverTime }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="是否发送至手机：">
                {{ rows.send == 1 ? "是" : "否" }}
              </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="买家手机号：">{{ rows.phone }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <FormItem label="买家邮箱："> {{ rows.email }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <FormItem label="买家备注："> {{ rows.userRemarks }} </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <FormItem label="发货内容：" v-if="rows.type == 1">
                <p v-for="list in rows.content" :key="list">{{list}}</p>
              </FormItem>
              </Col>
              <Col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <FormItem label="更多操作：">
                <Button type="success" :disabled="rows.status == 0?false:true" :loading="loading"
                  @click="Supplement(rows)" size="small">补单</Button>
              </FormItem>
              </Col>
            </Row>

            <!-- <Row>
              <Col>
              <FormItem label="买家评价："> 评价内容</FormItem>
              </Col>
              <Col>
              <FormItem label="发货内容：" v-if="rows.type == 2 || rows.status == 1">
                <Input v-model="rows.content" type="textarea" :autosize="{ minRows: 3, maxRows: 20 }"
                  placeholder="请输入发货内容或物流单号" style="width: 70%; margin-top: 10px"></Input>
              </FormItem>
              </Col>
            </Row> -->
          </Form>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getOrder,
    postSupplement,
    delOrder,
    getStatistics,
    delOrderAll,
  } from "@/api/admin";
  export default {
    data() {
      return {
        Modal: false,
        rows: {},
        Selection: [],
        pageIndex: 1,
        pageSize: 10,
        total: "",
        searchValue: "",
        searchType: 1,
        orderType: -1,
        columns: [{
            type: "selection",
            width: 60,
            align: "center",
          },

          {
            title: "商户订单号",
            align: "center",
            key: "out_trade_no",
            minWidth: 210,
          },
          {
            title: "商品名称",
            align: "center",
            key: "goods_name",
            minWidth: 150,
          },
          {
            title: "金额",
            align: "center",
            key: "price",
            minWidth: 100,
          },
          {
            title: "发货类型",
            align: "center",
            slot: "type",
            minWidth: 110,
          },
          {
            title: "支付方式",
            align: "center",
            slot: "payment",
            minWidth: 100,
          },
          {
            title: "创建时间",
            key: "addTime",
            align: "center",
            minWidth: 200,
          },
          {
            title: "状态",
            align: "center",
            slot: "status",
            minWidth: 100,
          },
          {
            title: "操作",
            minWidth: 160,
            align: "center",
            slot: "action",
            fixed: "right"

          },
        ],
        data: [],
        statistics: {},
        loading: false,
        loading1: false,
        loading2: false,
        load:true
      };
    },
    
    created() {
      this._getStatistics();
      if (this.$route.query.out_trade_no) {
        this.searchType = 2
        this.searchValue = this.$route.query.out_trade_no
        this.searchClick()
      } else {
        this._getData();
      }
    },
    watch: {
      orderType(newVal) {
        (this.pageIndex = 1), (this.load = true), this._getData();
      },
      searchValue(newVal) {
        if (newVal == "") {
          (this.pageIndex = 1), (this.load = true), this._getData();
        }
      },
    },
    methods: {
      // 获取列表
      _getData() {
        getOrder({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          orderType: this.orderType,
          searchValue: this.searchValue,
          searchType: this.searchValue ? this.searchType : 0,
        }).then((res) => {
          this.data = res.data.data;
          this.total = res.data.total;
          this.Selection = [];
          this.load = false
        });
      },

      // 获取订单统计
      _getStatistics() {
        getStatistics({}).then((res) => {
          this.statistics = res.data;
          let money = 0
          res.data.today_money.map(function(item){
            if(item){
              money = Number(money)+Number(item)
            }
          })
          this.statistics.today_money = money.toFixed(2)
        });
      },
      // 查看订单
      readOrder(row) {
        this.rows = row;
        this.Modal = true;
      },

      // 补单
      Supplement(row) {
        this.loading = true
        if (row.status == 0) {
          postSupplement({
            out_trade_no: row.out_trade_no,
            price: row.price,
          }).then((res) => {
            if (res.code == 200) {
              this.$Message.success({
                background: true,
                content: res.msg,
              });
              this._getData();
              this.Modal = false
            } else {
              this.$Message.error({
                background: true,
                content: res.msg,
              });
            }
            this.loading = false

          });
        } else {
          this.$Message.warning({
            background: true,
            content: '该订单无需补单',
          });
          this.loading = false

        }
      },
      // 删除
      del(id) {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除后无法恢复，是否继续？",
          onOk: () => {
            this.delFunction(id);
          },
        });
      },
      // 删除所选
      allDel() {
        let arr = [];
        this.Selection.map(function (item) {
          arr.push(item.out_trade_no);
        });
        this.del(arr);
      },
      // 删除方法
      delFunction(id) {
        this.loading2 = true
        this.load = true
        delOrder({
          id: id,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.loading2 = false
          this.Selection = [];
        });
      },
      // 删除全部未支付订单
      allDelNot() {
        this.$Modal.confirm({
          title: "删除确认",
          content: "删除后无法恢复，是否继续？",
          onOk: () => {
            this.loading1 = true
            delOrderAll().then((res) => {
              if (res.code == 200) {
                this.$Message.success({
                  background: true,
                  content: res.msg,
                });
                this._getData();
              } else {
                this.$Message.error({
                  background: true,
                  content: res.msg,
                });
              }
              this.loading1 = false
            });
          },
        });
      },
      // 搜索
      searchClick() {
        this.pageIndex = 1
        this.load = true
        this._getData();
      },
      // 分页跳转
      pageChange(val) {
        this.pageIndex = val;
        this.load = true
        this._getData();
      },
      pageSizeChange(val) {
        this.pageSize = val;
        this.pageIndex = 1
        this.load = true
        this._getData();
      },
      //多选
      handleSelectChange(val) {
        this.Selection = val;
      },
    },
  };
</script>

<style lang="less" scoped>
  @deep: ~">>>";

  .ivu-bg {
    box-shadow: 0 0 17px 0 rgba(130, 122, 122, 0.1);
    margin-bottom: 10px;
    border-radius: 0.35rem;
  }

  .ivu-text-center {
    text-align: center;
  }

  .ivu-mt {
    margin: 16px 0;
  }

  .ivu-form-item {
    margin-bottom: 0;
  }

  .w50 {
    width: 50%;
  }

  .del {
    text-decoration: line-through;
    color: #999;
  }

  .shop-img {
    width: 36px;
    height: 36px;
    margin: 0 auto;
    border-radius: 5px;
  }

  /deep/ .ivu-radio-wrapper-checked {
    background: #2d8cf0;
    color: #fff;
  }
</style>